import { useState, useEffect, useContext } from 'react';
import InfoPanel from './components/InfoPanel';
import MapPanel from './components/MapPanel';
import WidgetLoadingAnimation from 'components/Widgets/WidgetLoadingAnimation';
import { ErrorMessage } from 'components/Widgets/ErrorMessage';
import WidgetTimeUpdate from 'components/Widgets/WidgetTimeUpdate';
import { UniqueWidgetRefreshContext } from 'App';
import Cookies from 'js-cookie';
import useDataRefresh from 'hooks/useDataRefresh';

export default function SevereWeatherAlertsMap({
  fullScreen = false,
  widgetRefresh,
  setWidgetRefresh,
  preview,
  dimensions = [0, 0],
  sidebarOpen,
}) {
  const [selectedZone, setSelectedZone] = useState(null);
  const [selectedAlert, setSelectedAlert] = useState(null);
  const [error, setError] = useState({ state: false, message: '' });
  const [fetching, setFetching] = useState(true);

  const ROUTE = 'getAllActiveAlerts';

  useEffect(() => {
    setFetching(true);
  }, [widgetRefresh]);

  const dataRefresh = useDataRefresh();
  useEffect(() => {
    (async () => {
      try {
        setFetching(false);
      } catch (err) {
        setError({ state: true, message: err.message });
      }
    })();
  }, [dataRefresh.widgetRefresh]);

  if (error.state && !fetching) {
    return <ErrorMessage message={error.message} />;
  }
  if (fetching)
    return <WidgetLoadingAnimation widgetName={'SevereWeatherAlerts'} dimensions={dimensions} />;

  if (fullScreen)
    return (
      <div className="d-flex h-100 w-100 flex-column overflow-hidden">
        <WidgetTimeUpdate realtime route={'getAllActiveAlerts'} addMargin />
        <MapPanel
          fullScreen={fullScreen}
          selectedAlert={selectedAlert}
          setSelectedAlert={setSelectedAlert}
          selectedZone={selectedZone}
          setSelectedZone={setSelectedZone}
          setFetching={setFetching}
          sidebarOpen={sidebarOpen}
        />
        <div className="m-1 max-h-50 flex-shrink-1 overflow-auto">
          <InfoPanel
            fullScreen={fullScreen}
            selectedAlert={selectedAlert}
            setSelectedAlert={setSelectedAlert}
            selectedZone={selectedZone}
          />
        </div>
      </div>
    );

  //1 wide, 2 tall
  if (dimensions && (dimensions[1] || 0) >= 2)
    return (
      <div className="d-flex h-100 flex-column">
        <WidgetTimeUpdate realtime route={'getAllActiveAlerts'} />
        <MapPanel
          fullScreen={fullScreen}
          selectedAlert={selectedAlert}
          setSelectedAlert={setSelectedAlert}
          selectedZone={selectedZone}
          setSelectedZone={setSelectedZone}
          preview={preview}
          sidebarOpen={sidebarOpen}
        />
        <div className="m-1 max-h-50 flex-shrink-1 overflow-auto">
          <InfoPanel
            fullScreen={fullScreen}
            selectedAlert={selectedAlert}
            setSelectedAlert={setSelectedAlert}
            selectedZone={selectedZone}
          />
        </div>
      </div>
    );
  //1 wide, 1 tall
  if (dimensions && dimensions[0] === 1 && dimensions[1] === 1)
    return (
      <div className="d-flex flex-column h-100">
        <WidgetTimeUpdate realtime route={'getAllActiveAlerts'} />
        <MapPanel
          fullScreen={fullScreen}
          selectedAlert={selectedAlert}
          setSelectedAlert={setSelectedAlert}
          selectedZone={selectedZone}
          setSelectedZone={setSelectedZone}
          includePopup={true}
          preview={preview}
          sidebarOpen={sidebarOpen}
        />
      </div>
    );

  //2 wide, 1 tall
  if (dimensions && (dimensions[0] || 0) >= 2 && dimensions[1] === 1)
    return (
      <div className="d-flex h-100 flex-column">
        <WidgetTimeUpdate realtime route={'getAllActiveAlerts'} />
        <div className="d-flex flex-row h-100 overflow-hidden">
          <div className="mx-auto me-3 w-50 overflow-auto">
            <InfoPanel
              fullScreen={fullScreen}
              selectedAlert={selectedAlert}
              setSelectedAlert={setSelectedAlert}
              selectedZone={selectedZone}
            />
          </div>
          <MapPanel
            fullScreen={fullScreen}
            selectedAlert={selectedAlert}
            setSelectedAlert={setSelectedAlert}
            selectedZone={selectedZone}
            setSelectedZone={setSelectedZone}
            preview={preview}
            sidebarOpen={sidebarOpen}
          />
        </div>
      </div>
    );
}
